import { render, staticRenderFns } from "./GenerationPta.vue?vue&type=template&id=c58dc0ba"
import script from "./GenerationPta.vue?vue&type=script&lang=js"
export * from "./GenerationPta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports